import BaseApi from '@core/api/model';

export class TrancheApi extends BaseApi {
    static resource = 'tranches';
}

export default TrancheApi;
